export const cilSchool = ["24 24","<path d='M17.25 16.436l-5.25 2.953-5.25-2.953v-3.12l-1.5-0.833v4.831l6.75 3.797 6.75-3.797v-4.831l-1.5 0.833v3.12z'></path><path d='M12 2.155l-10.5 5.444v1.3l10.5 5.833 9-5v4.142h1.5v-6.275zM19.5 8.85l-7.5 4.167-8.54-4.744 8.54-4.428 8.54 4.428z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-school.js
// module id = null
// module chunks = 